/**
 * Implicit waits are waits that appear automatically if code called in a
 * wCall within a saga takes a little while to run.
 */
import { connect } from 'react-redux';
import { getImplicitWait, getExplicitWaitVisible } from 'phoenix2/state/wait/selectors';

import PureImplicitWait from './implicit-wait.jsx';

export const mapStateToProps = state => ({
    wait: getImplicitWait(state),
    // If there is an explicit waiting message, don't show the implicit one.
    hide: getExplicitWaitVisible(state),
});

export const connectImplicitWait = connect(mapStateToProps);

export const ImplicitWait = connectImplicitWait(PureImplicitWait);

export default ImplicitWait;
